import makeHttpRequest from './ajax';

export default {
    depositAccountData(zoneKey = '') {
        const url = `${WP_DEPOSITACCOUNTS_URL}/ads/?APIKey=ECE8D72E-4177-4ED5-B9F6-171DCFC4733F&esourceid=6292866&zoneKey=${zoneKey}`;
        const request = {
            url,
        };
        return makeHttpRequest(request).then((response) => {
            const result = JSON.parse(response);
            if (result.zones.length > 0) {
                return { status: true, data: result.zones[0].placements };
            }
            return { status: false };
        });
    },
    convertDaysToMonths(numberOfDays) {
        if (typeof numberOfDays === 'string') {
            return '';
        }
        if (numberOfDays) {
            const averageDaysInMonths = 30.4167;
            const numberOfMonths = Math.round(numberOfDays / averageDaysInMonths);
            return numberOfMonths > 1 ? `${numberOfMonths} months` : `${numberOfMonths} month`;
        }
        return '';
    },
    numFormatter(num) {
        if (num > 999 && num < 1000000) {
            return `${num / 1000}K`;
        }
        if (num > 1000000) {
            return `${num / 1000000}M`;
        }
        return num;
    },
    renderHealthGradeItem(healthGrade, isVisible, className) {
        const label = isVisible ? `<span>${healthGrade}</span>` : '<span style="visibility: hidden;">&nbsp</span>';
        return `<div class="${className}">${label}<span class="${className}-border"></span></div>`;
    },
    getFormattedDate(date) {
        const currentOrSpecificDate = date ? new Date(date) : new Date();
        return currentOrSpecificDate.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
    },
};
